
export const getRegion = state => state.dropDown.region;
export const getDropDown = state => state.dropDown;
export const getUserProfile = state => state.profile.profile;
export const getApiAlert = state => state.common.apiAlert;
export const getPinMenu = state => state.common.pinMenu;
export const getSelectedMenu = state => state.common.selectedMenu;
export const getFullLoad = state => state.common.fullLoad;
export const getSnackMsg = state => state.common.snackMsg;
export const getSelectedAgency = state => state.dropDown.selectedAgency;
